import React from 'react'

const Header = () => {
    return (
        <>
            <div id='header' className='relative -top-48'></div>
            <header className='p-12 md:p-24 lg:p-32 flex flex-col items-center justify-center text-center relative'>
                <img className='absolute top-0 left-0 w-32 md:w-60 lg:w-72' src={require(`../../assets/left-luggage.png`)} alt='right-background' />
                <img className='absolute bottom-0 right-0 w-24 md:w-48 lg:w-60' src={require(`../../assets/right-luggage.png`)} alt='right-background' />
                <h2 className='font-bold 
                text-sm md:text-xl lg:text-2xl
                mb-4 md:mb-6 lg:mb-8'>Getsemani</h2>
                <h1 className='
                text-3xl md:text-4xl lg:text-6xl
                mb-8 md:mb-12 lg:mb-16'><b>Near Sanur Beach</b> <br />Luggage Storage</h1>
                <p className='text-sm md:text-2xl'>Place to safely store your luggage<br />for just Rp.30K per day</p>
            </header>
        </>
    )
}

export default Header